import { Icon } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { CloudUploadIcon } from 'lucide-react'
import React, { useEffect, useRef } from 'react'
import {
  Dropzone,
  DropZoneArea,
  DropzoneTrigger,
  useDropzone,
} from '@/components/ui/dropzone'

type IssueAttachmentDropzoneProps = {
  onAddFiles: (files: File[]) => void
}

const IssueAttachmentDropzone: React.FC<IssueAttachmentDropzoneProps> = ({
  onAddFiles,
}) => {
  const translations = useTranslate({
    uploadFiles: 'documents.upload-files',
    dragAndDrop: 'documents.drag-and-drop-to-upload',
    chooseFile: 'common.choose-file',
  })

  const onAddFilesRef = useRef(onAddFiles)
  const batchRef = useRef<File[]>([])

  useEffect(() => {
    onAddFilesRef.current = onAddFiles
  })

  const dropzone = useDropzone<undefined, string>({
    noDragEventsBubbling: true,
    onDropFile: async (file: File) => {
      batchRef.current.push(file)
      return { status: 'success', result: undefined }
    },
    onAllUploaded: () => {
      if (batchRef.current.length > 0) {
        onAddFilesRef.current(batchRef.current)
        batchRef.current = []
      }
    },
  })

  return (
    <Dropzone {...dropzone}>
      <DropZoneArea onClick={e => e.stopPropagation()}>
        <div className="flex w-full flex-col items-center gap-3 p-10 text-center">
          <CloudUploadIcon className="size-8" />
          <div>
            <p className="font-semibold">{translations.uploadFiles}</p>
            <p className="text-sm text-muted-foreground">
              {translations.dragAndDrop}
            </p>
          </div>

          <DropzoneTrigger
            className="mt-1 flex items-center gap-2 rounded-lg bg-transparent px-6 text-sm font-medium text-white"
            style={{ backgroundColor: '#1D9E75', height: 38 }}
          >
            <Icon icon="paperclip" type="regular" />
            {translations.chooseFile}
          </DropzoneTrigger>
        </div>
      </DropZoneArea>
    </Dropzone>
  )
}

export default IssueAttachmentDropzone
